'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var LOAD = exports.LOAD = 'REDUX_STORAGE_LOAD';
var SAVE = exports.SAVE = 'REDUX_STORAGE_SAVE';


//////////////////
// WEBPACK FOOTER
// ./~/redux-storage/build/constants.js
// module id = 123
// module chunks = 0